import React from 'react'

const LightningIcon = ({ className = '', color = '#1772F5' }) => {
  return (
    <svg
      width="18"
      height="26"
      viewBox="0 0 18 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.2832 0.110485C14.4422 0.202685 14.5653 0.346094 14.6323 0.517284C14.6993 0.688474 14.7063 0.877325 14.6521 1.05299L11.7254 10.5625H17.1253C17.284 10.5624 17.4392 10.6088 17.5719 10.696C17.7045 10.7831 17.8087 10.9072 17.8716 11.0529C17.9345 11.1986 17.9534 11.3595 17.9259 11.5158C17.8984 11.6721 17.8257 11.8169 17.7168 11.9324L4.71682 25.7449C4.59104 25.8786 4.42365 25.9658 4.24196 25.9923C4.06026 26.0187 3.87496 25.9828 3.71626 25.8905C3.55757 25.7981 3.43483 25.6548 3.36806 25.4837C3.30129 25.3127 3.29442 25.1241 3.34857 24.9486L6.2752 15.4375H0.875324C0.716635 15.4375 0.5614 15.3911 0.428784 15.304C0.296167 15.2168 0.191974 15.0928 0.129067 14.9471C0.0661604 14.8014 0.0472933 14.6405 0.074795 14.4842C0.102297 14.3279 0.174963 14.1831 0.283824 14.0676L13.2838 0.25511C13.4095 0.121534 13.5766 0.0343844 13.758 0.0078318C13.9395 -0.0187208 14.1246 0.0168852 14.2832 0.10886V0.110485ZM2.75545 13.8125H7.37532C7.50248 13.8125 7.62786 13.8423 7.74139 13.8995C7.85492 13.9568 7.95342 14.0399 8.02898 14.1422C8.10454 14.2445 8.15504 14.363 8.17641 14.4884C8.19779 14.6137 8.18946 14.7423 8.15207 14.8639L5.92907 22.0837L15.2436 12.1875H10.6253C10.4982 12.1875 10.3728 12.1577 10.2593 12.1004C10.1457 12.0432 10.0472 11.9601 9.97167 11.8578C9.89611 11.7555 9.84561 11.6369 9.82423 11.5116C9.80285 11.3863 9.81119 11.2576 9.84857 11.1361L12.0716 3.91624L2.75545 13.8125Z"
        fill={color}
      />
    </svg>
  )
}

export default LightningIcon
